import { render, staticRenderFns } from "./plus.vue?vue&type=template&id=f97a7028"
import script from "./plus.vue?vue&type=script&lang=js"
export * from "./plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports